function el(tagName, attributes, children) {
    if (typeof tagName !== 'string') {
        throw new Error('tagName must be a string');
    }

    let element = document.createElement(tagName);

    if (attributes && typeof attributes === 'object') {
        Object.keys(attributes).forEach(function (i) {
            // Set event handlers
            if (/on[A-Z][a-z]/.test(i)) {
                element[i.toLowerCase()] = attributes[i];
            } else {
                // Set attributes
                element.setAttribute(i, attributes[i]);
            }
        });
    }

    if (typeof children === 'string') {
        element.innerHTML = children;
    } else if (children instanceof Array) {
        children.forEach(function (child) {
            element.appendChild(child);
        });
    }

    return element;
}

/*
 * TypoReporter.
 * @param object props. Object of options.
 * @param Element
 */
function TypoReporter(props, rootNode) {
    props = props || {};
    if (!rootNode) {
        throw new Error('"rootNode" is not passed');
    }
    if (!props.formId) {
        throw new Error('"formId" option is not defined');
    }
    props.snippetFieldName = props.snippetFieldName || 'entry.13240190';
    props.urlFieldName = props.urlFieldName || 'entry.238687347';
    props.commentFieldName = props.commentFieldName || 'entry.1447231081';
    props.endpointUrl = props.endpointUrl ||
        'https://cors-anywhere.herokuapp.com/https://docs.google.com/forms/d/e/' +
        props.formId + '/formResponse?embedded=true';
    props.offset = props.offset || 50;
    props.translations = props.translations || this.translations;
    props.locale = props.locale || 'en';
    if (!props.translations[props.locale]) {
        throw new Error('No translations defined for locale ' + props.locale);
    }
    this.i18n = props.translations[props.locale];
    this.props = props;
    this.node = rootNode;
    this.state = {};

    this.lastSnippet = null;

    // Bind methods
    this.submit = this.submit.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.closeDialog = this.closeDialog.bind(this);

    // Setup key bindings
    document.addEventListener('keydown', function (event) {
        if (event.ctrlKey && event.which === 13 && document.getSelection().toString()) {
            this.showDialog();
        }
        if (event.which === 27) {
            this.closeDialog();
        }
    }.bind(this));

    this.refresh();
}

TypoReporter.prototype.translations = {
    en: {
        header: 'Report a mistake on the page',
        messageLabel: 'There is a mistake in the following text:',
        commentLabel: '<strong>Do you want to send a notice to a webmaster?</strong>',
        send: '<strong>Send</strong>',
        sending: 'Sending',
        cancel: 'Cancel',
        error: 'Error! Something went wrong...',
        noSelection: 'Select erron in text',
        close: 'Close',
    },
    ru: {
        header: 'Сообщите об ошибке на странице',
        messageLabel: 'Ошибка содержится в следующем тексте:',
        commentLabel: 'Отправить сообщение об ошибке редактору сайта?',
        send: 'Отправить',
        sending: 'Отправляю',
        cancel: 'Отмена',
        error: 'Ошибка! Что-то пошло не так...',
        noSelection: 'Сначала выделите ошибку в тексте',
        close: 'Закрыть',
    }
};

TypoReporter.prototype.render = function () {
    let state = this.state;
    let i18n = this.i18n;

    if (!state.isOpen) {
        return false;
    }

    if (!state.snippet) {
        return el('div', null, [
            el('div', {class: 'typo-popup__veil', onClick: this.closeDialog}),
            el('div', {class: 'typo-popup'}, [
                el('div', {class: 'typo-popup__header'}, i18n.error),
                el('div', {class: 'typo-popup__label'}, i18n.noSelection),
                el('div', {class: 'typo-popup__buttons'}, [
                    el('button', {
                        type: 'button',
                        class: 'typo-popup__cancel btn btn-gray',
                        onClick: this.closeDialog
                    }, i18n.close)
                ]),
                el('div', null, state.isError && i18n.error)
            ])
        ]);
    }

    return el('div', null, [
        el('div', {class: 'typo-popup__veil', onClick: this.closeDialog}),
        el('div', {class: 'typo-popup'}, [
            el('div', {class: 'typo-popup__header'}, i18n.header),
            el('div', {class: 'typo-popup__label'},
                '<b>ВНИМАНИЕ!</b> Пожалуйста, используйте данную форму только для отправки отчётов об ошибках. Будьте подробны в формулировках; перед отправкой проверьте оригинал источника на английском. При возникновении технической ошибки или необходимости поделиться изображением или получить обратную связь вы можете написать на нашем <a href="https://discord.gg/SZQrCZYHzH">Discord сервере</a>.'),
            el('div', {class: 'typo-popup__label'}, i18n.messageLabel),
            el('div', {class: 'typo-popup__message'}, state.snippet.replace('>>>', '<u class="typo-popup__heighlight">').replace('<<<', '</u>')),
            el('textarea', {
                class: 'typo-popup__comment',
                placeholder: 'Ваш комментарий',
                onKeyup: this.handleCommentChange
            }, state.comment),
            //el('div', {class: 'typo-popup__label'}, i18n.commentLabel),
            el('div', {class: 'typo-popup__buttons'}, [
                el('button', {
                    type: 'button',
                    class: 'typo-popup__submit btn btn-green',
                    onClick: this.submit
                }, state.isSending ? i18n.sending : i18n.send),
                el('button', {
                    type: 'button',
                    class: 'typo-popup__cancel btn btn-gray',
                    onClick: this.closeDialog
                }, i18n.cancel)
            ]),
            el('div', null, state.isError && i18n.error)
        ])
    ]);
};

TypoReporter.prototype.refresh = function () {
    let node = this.node;
    node.innerHTML = '';
    let nodeTree = this.render();
    if (nodeTree) {
        node.appendChild(nodeTree);
    }
};

TypoReporter.prototype.submit = function () {
    let state = this.state;
    let props = this.props;

    state.isSending = true;
    this.refresh();

    let formData = new FormData();
    formData.append(props.snippetFieldName, state.snippet);
    formData.append(props.commentFieldName, state.comment);
    formData.append(props.urlFieldName, state.URI);

    let request = new XMLHttpRequest();
    request.open('POST', props.endpointUrl, true);
    request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
            this.closeDialog();
        } else {
            state.isError = true;
            state.isSending = false;
            this.refresh();
        }
    }.bind(this);
    request.onerror = function () {
        state.isError = true;
        state.isSending = false;
        this.refresh();
    }.bind(this);
    request.send(formData);
};

TypoReporter.prototype.saveURI = function (parent) {
    let uri = window.location;

    let path = parent.closest('[data-typo-path]');
    if (path) {
        uri = path.getAttribute('data-typo-path');
    }

    let ref = parent.closest('[data-typo-ref]');
    if (ref) {
        uri += "#" + ref.getAttribute('data-typo-ref');
    }

    return this.state.URI = uri;
}

TypoReporter.prototype.saveSnippet = function () {
    let snippet = this.getSnippet(true);
    if (snippet) {
        this.lastSnippet = snippet;
    }
}

TypoReporter.prototype.getSnippet = function (force) {
    force = force || false;
    if (this.lastSnippet && !force) {
        return this.lastSnippet;
    }

    let props = this.props;

    let selection = document.getSelection();
    let selectionText = selection.toString();
    if (!selectionText) {
        return false;
    }

    let range = selection.getRangeAt(0);

    let preRange = document.createRange();
    let postRange = document.createRange();
    preRange.setStartBefore(range.startContainer.ownerDocument.body);
    preRange.setEnd(range.startContainer, range.startOffset);
    postRange.setStart(range.endContainer, range.endOffset);
    postRange.setEndAfter(range.endContainer.ownerDocument.body);
    let pre = preRange.toString().substr(-props.offset);
    let post = postRange.toString().substr(0, props.offset);
    let result = pre + '>>>' + selectionText + '<<<' + post;
    let sanitize = document.createElement('div');
    sanitize.innerHTML = result;
    return sanitize.innerText.replace(/\r?\n|\r/g, '').replace(/\s+/g, ' ');

};

TypoReporter.prototype.showDialog = function () {
    let state = this.state;
    state.snippet = this.getSnippet();
    //if (state.snippet) {
    state.isOpen = true;
    this.refresh();
    //}
};

TypoReporter.prototype.closeDialog = function () {
    // Completely reset the state
    this.state = {};
    this.refresh();
};

TypoReporter.prototype.handleCommentChange = function (event) {
    this.state.comment = event.target.value;
};

document.addEventListener('DOMContentLoaded', () => {

    if (document.querySelectorAll("textarea.editor").length > 0) {
        return;
    }

    if (document.querySelectorAll("div.editorio").length > 0) {
        return;
    }

    const rootNode = HTML.createElement('div', ['typo-reporter', 'card__article-body']);
    document.body.appendChild(rootNode);
    TypoReporter.instance = new TypoReporter({
        formId: '1157',
        locale: 'ru',
        offset: 70,
        endpointUrl: '/api/typo/action/post/',
        snippetFieldName: 'context',
        commentFieldName: 'comment',
        urlFieldName: 'uri'
    }, rootNode);

    const buttonNode = newElement('button.typo-button')
    let buttonIcon = newElement('span.typo-button__icon')
    let buttonText = newElement('span.typo-button__text')
    buttonIcon.appendChild(drawIcon('warning', 20))
    buttonText.innerText = 'Сообщить об ошибке'
    buttonNode.appendChild(buttonIcon)
    buttonNode.appendChild(buttonText)
    buttonNode.style.display = 'none'

    buttonNode.onclick = () => TypoReporter.instance.showDialog();
    document.body.appendChild(buttonNode);

    document.addEventListener("selectionchange", (event) => {
        let selection = window.getSelection();
        if (!selection.rangeCount) {
            return;
        }

        let parent = selection.getRangeAt(0).commonAncestorContainer;
        if (parent.nodeType !== 1) {
            parent = parent.parentNode;
        }

        let card = parent.closest('.typoable');
        if (!card) {
            return;
        }

        TypoReporter.instance.saveSnippet();
        TypoReporter.instance.saveURI(parent);
        let visible = Boolean(window.getSelection().toString());
        window.setTimeout(() => {
            buttonNode.style.display = 'flex';
            buttonNode.classList.toggle('active', visible);
        }, 200);
    })


})